import React from 'react';
export default (
  <svg width="33" height="25" viewBox="0 0 33 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.25" y="0.25" width="32.5" height="24.5" rx="4.75" stroke="black" stroke-width="0.5"/>
<rect x="9.42969" y="4.35156" width="14.1429" height="16.3043" rx="5" fill="white"/>
<path d="M15.3225 6.38962H11.1975V11.1451H15.3225V6.38962Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.8047 6.38962H17.6797V11.1451H21.8047V6.38962Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.8047 13.8624H17.6797V18.6179H21.8047V13.8624Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.3225 13.8624H11.1975V18.6179H15.3225V13.8624Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);
